module.exports = __webpack_public_path__ + "static/media/kigali-map-print.a18ff6ab.jpg";